<template>
  <nav class="bg-white border-b border-gray-200 p-4 mb-4 shadow-sm">
    <div class="container mx-auto flex flex-col items-center">
      <router-link :to="{ name: 'Home' }" class="max-w-[180px] pb-4 md:pb-0 mr-2">
        <Logo/>
      </router-link>
      <ul class="list flex w-full items-center gap-2 text-sm font-semibold">
        <li>
          <router-link
            :to="{ name: 'Home' }"
            :class="[
              'inline-flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-200',
              isActive('Home')
                ? 'bg-blue-500 text-white  shadow-md'
                : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
            ]"
          >
            <font-awesome-icon icon="chart-line" class="text-base"/>
            <span>Dashboard</span>
          </router-link>
        </li>
        <li class="mr-auto">
          <router-link
            :to="{ name: 'Tags' }"
            :class="[
              'inline-flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-200',
              isActive('Tags')
                ? 'bg-blue-500 text-white  shadow-md'
                : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
            ]"
          >
            <font-awesome-icon icon="tag" class="text-base"/>
            <span>Mijn tags</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'User' }" class="p-2 text-xl hover:text-black ">
            <span> <font-awesome-icon icon="circle-user"/></span>
          </router-link>
        </li>
        <li>
          <button @click="logoutUser" class="p-2 text-xl hover:text-black ">
            <span><font-awesome-icon icon="right-from-bracket"/></span>
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>


<script>
import {mapActions, mapStores} from 'pinia'
import {useAuthStore} from '@/stores/auth.js'
import Logo from "@/components/Logo.vue";
import {toast} from "vue3-toastify";

export default {
  components: {Logo},
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return this.authStore?.currentUser
    },
  },
  methods: {
    ...mapActions(useAuthStore, ['logout']),
    isActive(routeName) {
      // For Tags, also consider Tags/new and Tags/edit as active
      if (routeName === 'Tags') {
        return this.$route.name === 'Tags' ||
               this.$route.name === 'Tags/new' ||
               this.$route.name === 'Tags/edit'
      }
      // For other routes, exact match
      return this.$route.name === routeName
    },
    logoutUser() {
      this.logout()
        .then(() => {
          this.$router.push({name: 'Login'})
        })
    }
  },
}
</script>
